export const environment = {
  production: true,
  apiUrl: 'https://tools.adcore.com/api'
};
